import StorRequiredFields from "./StorRequiredFields";
import MarketObservationRequiredFields from "./MarketObservationRequiredFields";
import HelpDeskRequiredFields from "./HelpDeskStorRequiredFields";
import SegnalazioneType from "../../../shared/variables/SegnalazioniType";
import CONSTANTS from "../../../shared/utils/Constants";
import StorRequiredInternalFields from "./StorRequiredInternalFields";
import MarketObservationRequiredInternalFields from "./MarketObservationRequiredInternalFields"

const RequiredFieldsChecker = {

    checkIfFieldIsRequired: function(section : string, subsection : string, fieldLabel : string, segnalazioneType : string, ldapSource : string) {
        let requiredFields
        if(ldapSource.toLowerCase().includes(CONSTANTS.internalUserRole)){
            switch (segnalazioneType) {
                case SegnalazioneType.STOR:
                    requiredFields = StorRequiredInternalFields
                    break
                case SegnalazioneType.MARKET_OBSERVATION:
                    requiredFields = MarketObservationRequiredInternalFields
                    break
                default:
                    requiredFields = HelpDeskRequiredFields
                    break
            } 
        }
        else if(ldapSource === CONSTANTS.externalUserRole){
            switch (segnalazioneType) {
                case SegnalazioneType.STOR:
                    requiredFields = StorRequiredFields
                    break
                case SegnalazioneType.MARKET_OBSERVATION:
                    requiredFields = MarketObservationRequiredFields
                    break
                default:
                    requiredFields = HelpDeskRequiredFields
                    break
            } 
        } else {
            switch (segnalazioneType) {
                case SegnalazioneType.STOR:
                    requiredFields = StorRequiredFields
                    break
                case SegnalazioneType.MARKET_OBSERVATION:
                    requiredFields = MarketObservationRequiredFields
                    break
                default:
                    requiredFields = HelpDeskRequiredFields
                    break
            }
        }
        return requiredFields[section]
            && requiredFields[section][subsection]
            && requiredFields[section][subsection].includes(fieldLabel)
    }

}

export default RequiredFieldsChecker
